import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./DeclinedGuarantees";

const DeclinedGuarantees = lazy(() => import("./DeclinedGuarantees"));

export default (props: Props) => (
  <Page>
    <DeclinedGuarantees {...props} />
  </Page>
);
